module.exports = __webpack_public_path__ + "static/media/discord_white.48fb3153.svg";